import React, { createContext, useContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const SuperAdminAuthContext = createContext(null);

export const SuperAdminAuthProvider = ({ children }) => {
    const [superAdmin, setSuperAdmin] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        const token = localStorage.getItem('superAdminToken');
        const adminData = localStorage.getItem('superAdminInfo');
        if (token && adminData) {
            setSuperAdmin(JSON.parse(adminData));
        }
    }, []);

    const login = (token, adminInfo) => {
        localStorage.setItem('superAdminToken', token);
        localStorage.setItem('superAdminInfo', JSON.stringify(adminInfo));
        setSuperAdmin(adminInfo);
        navigate('/superadmin/dashboard');
    };

    const logout = () => {
        localStorage.removeItem('superAdminToken');
        localStorage.removeItem('superAdminInfo');
        setSuperAdmin(null);
        navigate('/superadmin/login');
    };

    return (
        <SuperAdminAuthContext.Provider value={{ superAdmin, login, logout }}>
            {children}
        </SuperAdminAuthContext.Provider>
    );
};

export const useSuperAdminAuth = () => useContext(SuperAdminAuthContext);
